import produce from 'immer'

import { Types } from './actions'

export const INITIAL_STATE = {
  loadings: {
    getDashboard: false
  },
  errors: {
    getDashboard: false
  },
  attempts: {
    getDashboard: 0
  },
  welcomeData: {},
  dashboardData: {}
}

export default function dashboardReducers (state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case Types.updateModalWelcome: {
        draft.welcomeData = action?.payload?.welcomeData || {}
        break
      }
      case Types.getDashboard: {
        draft.loadings.getDashboard = true
        draft.attempts.getDashboard = 0
        break
      }
      case Types.updateDashboard: {
        draft.loadings.getDashboard = false
        draft.attempts.getDashboard = 1
        draft.errors.getDashboard = action?.payload?.error || false
        draft.dashboardData = action?.payload?.dashboardData || {}
        break
      }
      default:
    }
  })
}
